import clsx from 'clsx';
import { Users } from 'lucide-react';

/** Cores das equipes (distintas do vermelho da marca, usado em botões e alertas). */
const PALETTE = ['#2563eb', '#0d9488', '#7c3aed', '#b45309', '#db2777', '#15803d', '#0891b2', '#4f46e5', '#9333ea', '#0f766e'];

/** Mesma equipe, mesma cor (pelo nome), em qualquer tela e para todos os operadores. */
export function teamColor(name: string): string {
  let h = 0;
  for (const ch of name.trim().toLowerCase()) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

/** Selo da equipe do atendimento. Sem equipe: selo neutro (fila geral). */
export function TeamBadge({ name, size = 'sm', showEmpty = false }: { name: string | null; size?: 'sm' | 'md'; showEmpty?: boolean }) {
  if (!name) {
    if (!showEmpty) return null;
    return (
      <span className={clsx('inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-dashed border-border text-fg-soft', size === 'md' ? 'px-2 py-0.5 text-sm' : 'px-1.5 py-0.5 text-[11px]')}>
        <Users className={size === 'md' ? 'size-3.5' : 'size-3'} /> sem equipe
      </span>
    );
  }
  const color = teamColor(name);
  return (
    <span
      className={clsx('inline-flex shrink-0 items-center gap-1 rounded-md font-semibold', size === 'md' ? 'px-2 py-0.5 text-sm' : 'px-1.5 py-0.5 text-[11px] leading-none')}
      style={{ color, backgroundColor: `${color}1f`, boxShadow: `inset 0 0 0 1px ${color}40` }}
      title={`Equipe ${name}`}
    >
      <Users className={size === 'md' ? 'size-3.5' : 'size-3'} />
      {name}
    </span>
  );
}
